<app-carousel
    [typeSearch]="'Employee'"
></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <br />
        <ng-container [formGroup]="form">
            <div class="card mb-2">
                <div class="card-body">
                    <div class="row mt-0 mb-2">
                        <div class="col-md-6 col-sm-6 col-12">
                            <h5 class="mt-0 mb-2">
                                <i class="fa-regular fa-address-card"></i>
                                @if (resumeId()) {
                                    {{form.get('name')?.value}}
                                }@else {
                                    Crear un curriculum
                                }
                            </h5>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12">
                        </div>
                    </div>
                    <hr class="mt-2 mb-2" />
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Nombre del curriculum</label>
                                <div>
                                    <input formControlName="name" type="text" class="form-control" 
                                    [ngClass]="{'is-invalid': form.get('name')?.invalid && (form.get('name')?.touched || form.get('name')?.dirty)}"/>
                                    @if (form.get('name')?.invalid && (form.get('name')?.touched || form.get('name')?.dirty)) {
                                        @if (form.get('name')?.errors?.['required'] == true) {
                                            <div class="invalid-feedback">
                                                Este campo es requerido
                                            </div>
                                        }
                                        @if (form.get('name')?.hasError('maxlength')) {
                                            <div class="invalid-feedback">
                                                Este campo no puede exceder los {{form.get('name')?.errors?.['maxlength']?.requiredLength}} caracteres
                                            </div>
                                        }
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Expectativa Salarial</label>
                                <div>
                                    <select formControlName="salaryExpectationId" class="form-control">
                                        <option [ngValue]="null"></option>
                                        @for (item of salaryExpectationOptions; track $index) {
                                            <option [ngValue]="item.id">{{item.text}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Tipo</label>
                                <div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="typeId" class="form-check-input" type="radio" name="typeId" id="TipoCV1" [value]="1">
                                        <label class="form-check-label" for="TipoCV1">Web</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="typeId" class="form-check-input" type="radio" name="typeId" id="TipoCV2" [value]="2">
                                        <label class="form-check-label" for="TipoCV2">PDF</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Visibilidad</label>
                                <div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="isPublic" class="form-check-input" type="radio" name="isPublic" id="Visibilidad1" [value]="true">
                                        <label class="form-check-label" for="Visibilidad1">Publico</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="isPublic" class="form-check-input" type="radio" name="isPublic" id="Visibilidad2" [value]="false">
                                        <label class="form-check-label" for="Visibilidad2">Privado</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Disponibilidad para Viajar</label>
                                <div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="travelAvailability" class="form-check-input" type="radio" name="travelAvailability" id="DisponibilidadViaje1" [value]="1">
                                        <label class="form-check-label" for="DisponibilidadViaje1">Si</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="travelAvailability" class="form-check-input" type="radio" name="travelAvailability" id="DisponibilidadViaje2" [value]="2">
                                        <label class="form-check-label" for="DisponibilidadViaje2">No</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="travelAvailability" class="form-check-input" type="radio" name="travelAvailability" id="DisponibilidadViaje3" [value]="3">
                                        <label class="form-check-label" for="DisponibilidadViaje3">Ocasionalmente</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Permiso de Trabajo</label>
                                <div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="workPermit" class="form-check-input" type="radio" name="workPermit" id="PermisoTrabajo1" [value]="true">
                                        <label class="form-check-label" for="PermisoTrabajo1">Si</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="workPermit" class="form-check-input" type="radio" name="workPermit" id="PermisoTrabajo2" [value]="false">
                                        <label class="form-check-label" for="PermisoTrabajo2">No</label>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>¿Curriculum por defecto (Principal)?</label>
                                <div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="isDefault" class="form-check-input" type="radio" name="isDefault" id="isDefault1" [value]="true">
                                        <label class="form-check-label" for="isDefault1">Si</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="isDefault" class="form-check-input" type="radio" name="isDefault" id="isDefault2" [value]="false">
                                        <label class="form-check-label" for="isDefault2">No</label>
                                    </div>
                                </div>
                                <small class="form-text text-muted">Si se selecciona "Sí", este curriculum se utilizará por defecto para el comparativo de ofertas.</small>
                            </div>
                        </div>
                        <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label>¿Cómo usaré mi curriculum?</label>
                                <div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="publishResumeAsFreelancer" class="form-check-input" type="radio" name="publishResumeAsFreelancer" id="PublicarCV1" [value]="true">
                                        <label class="form-check-label" for="PublicarCV1">Como profesional independiente</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input formControlName="publishResumeAsFreelancer" class="form-check-input" type="radio" name="publishResumeAsFreelancer" id="PublicarCV2" [value]="false"> 
                                        <label class="form-check-label" for="PublicarCV2">Como profesional que busca un trabajo en una empresa</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if(form.get('publishResumeAsFreelancer')?.value) {
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Tipo de cobro</label>
                                    <div>
                                        <select formControlName="chargeTypeId" class="form-control">
                                            <option [ngValue]="null"></option>
                                            @for (item of chargeTypeOptions; track $index) {
                                                <option [ngValue]="item.id">{{item.text}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Monto a cobrar por tipo</label>
                                    <div>
                                        <input formControlName="amountToChargePerType" type="number" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        }
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label>Comentarios Adicionales</label>
                                <div>
                                    <textarea formControlName="description" class="form-control" rows="4"
                                    [ngClass]="{'is-invalid': form.get('description')?.invalid && (form.get('description')?.touched || form.get('description')?.dirty)}"></textarea>
                                    @if (form.get('description')?.invalid && form.get('description')?.touched) {
                                        @if (form.get('description')?.hasError('maxlength')) {
                                            <div class="invalid-feedback">
                                                Este campo no puede exceder los {{form.get('description')?.errors?.['maxlength']?.requiredLength}} caracteres
                                            </div>
                                        }
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <ul class="nav nav-tabs theme-tabs" id="tabcv" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="tabcv-01-tab" (click)="selectedTab.set('tabcv-01-tab')" data-bs-toggle="tab" data-bs-target="#tabcv-01-tab-pane" type="button" role="tab" aria-controls="tabcv-01-tab-pane" aria-selected="true">
                        <i class="fa-solid fa-graduation-cap"></i>
                        Educación
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tabcv-07-tab" (click)="selectedTab.set('tabcv-07-tab')" data-bs-toggle="tab" data-bs-target="#tabcv-07-tab-pane" type="button" role="tab" aria-controls="tabcv-07-tab-pane" aria-selected="false">
                        <i class="fa-solid fa-lightbulb"></i>
                        Habilidades
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tabcv-02-tab" (click)="selectedTab.set('tabcv-02-tab')" data-bs-toggle="tab" data-bs-target="#tabcv-02-tab-pane" type="button" role="tab" aria-controls="tabcv-02-tab-pane" aria-selected="false">
                        <i class="fa-solid fa-briefcase"></i>
                        Experiencia Laboral
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tabcv-06-tab" (click)="selectedTab.set('tabcv-06-tab')" data-bs-toggle="tab" data-bs-target="#tabcv-06-tab-pane" type="button" role="tab" aria-controls="tabcv-06-tab-pane" aria-selected="false">
                        <i class="fa-solid fa-user-tie"></i>
                        Referencias
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tabcv-03-tab" (click)="selectedTab.set('tabcv-03-tab')" data-bs-toggle="tab" data-bs-target="#tabcv-03-tab-pane" type="button" role="tab" aria-controls="tabcv-03-tab-pane" aria-selected="false">
                        <i class="fa-regular fa-id-card"></i>
                        Certificaciones
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tabcv-04-tab" (click)="selectedTab.set('tabcv-04-tab')" data-bs-toggle="tab" data-bs-target="#tabcv-04-tab-pane" type="button" role="tab" aria-controls="tabcv-04-tab-pane" aria-selected="false" tabcv-04>
                        <i class="fa-regular fa-file-lines"></i>
                        Documentos
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tabcv-05-tab" (click)="selectedTab.set('tabcv-05-tab')" data-bs-toggle="tab" data-bs-target="#tabcv-05-tab-pane" type="button" role="tab" aria-controls="tabcv-05-tab-pane" aria-selected="false" tabcv-05
                    [ngClass]="{'text-danger': form.get('templateId')?.invalid && (form.get('templateId')?.touched || form.get('templateId')?.dirty)
                        && selectedTab() != 'tabcv-05-tab'
                    }">
                        <i class="fa-solid fa-file-lines"></i>
                        Plantilla
                    </button>
                </li>
            </ul>
            <div class="tab-content" id="tabcvContent">
                <div class="tab-pane fade show active" id="tabcv-01-tab-pane" role="tabpanel" aria-labelledby="tabcv-01-tab" tabindex="0">
                   <app-cv-educations [resumeId]="resumeId() ?? null"/>
                </div>
                <div class="tab-pane fade" id="tabcv-07-tab-pane" role="tabpanel" aria-labelledby="tabcv-07-tab" tabindex="0">
                    <app-cv-skills [resumeId]="resumeId() ?? null"/>
                 </div>
                <div class="tab-pane fade" id="tabcv-02-tab-pane" role="tabpanel" aria-labelledby="tabcv-02-tab" tabindex="0">
                   <app-cv-employments [resumeId]="resumeId() ?? null"/>
                </div>
                <div class="tab-pane fade" id="tabcv-06-tab-pane" role="tabpanel" aria-labelledby="tabcv-06-tab" tabindex="0">
                    <app-cv-references [resumeId]="resumeId() ?? null"/>
                 </div>
                <div class="tab-pane fade" id="tabcv-03-tab-pane" role="tabpanel" aria-labelledby="tabcv-03-tab" tabindex="0">
                    <app-cv-certifications [resumeId]="resumeId() ?? null"/>
                </div>
                <div class="tab-pane fade" id="tabcv-04-tab-pane" role="tabpanel" aria-labelledby="tabcv-04-tab" tabindex="0">
                  <app-cv-documents [resumeId]="resumeId() ?? null"/>
                </div>
                <div class="tab-pane fade" id="tabcv-05-tab-pane" role="tabpanel" aria-labelledby="tabcv-05-tab" tabindex="0">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="form-group mb-3">
                                <label class="required-field">Seleccionar plantilla</label>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="list-group">
                                            @for (template of resumeTemplatesOptions; track template.id) {
                                                <button type="button" 
                                                        class="list-group-item list-group-item-action d-flex align-items-center"
                                                        [class.active]="form.get('templatePreviewId')?.value == template.code"
                                                        (click)="selectTemplate(template)">
                                                    <span class="me-auto">{{template.text}}</span>
                                                    <i class="fa-solid fa-check ms-2" *ngIf="form.get('templatePreviewId')?.value == template.code"></i>
                                                </button>
                                            }
                                            @if (form.get('templateId')?.invalid && form.get('templateId')?.touched) {
                                                @if (form.get('templateId')?.errors?.['required'] == true) {
                                                    <div class="text-danger">
                                                        Este campo es requerido
                                                    </div>
                                                }
                                            }
                                        </div>
                                       
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card">
                                            <div class="card-header">
                                                <h6 class="mb-0">Vista previa</h6>
                                            </div>
                                            <div class="card-body text-center">
                                                @if (form.get('templatePreviewId')?.value) {
                                                    <img [src]="API_URL+'/File/ViewFile/' + form.get('templatePreviewId')?.value" 
                                                         class="img-fluid border" 
                                                         alt="Vista previa de plantilla"
                                                         style="max-height: 400px;">
                                                } @else {
                                                    <div class="text-muted p-5">
                                                        <i class="fa-regular fa-image fa-3x mb-3"></i>
                                                        <p>Seleccione una plantilla para ver la vista previa</p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-start mt-3 mb-3">
                <div class="form-check form-check-inline">
                    <input formControlName="declareInformationIsTrue" class="form-check-input" type="checkbox" id="TerminosCondiciones"
                    name="declareInformationIsTrue" [value]="true">
                    <label class="form-check-label" for="TerminosCondiciones">
                        Declaro que la información proporcionada es verídica y completa.
                    </label>
                </div>
                <div class="form-check form-check-inline">
                    <input formControlName="consentForSelectionProcess" class="form-check-input" type="checkbox" id="PoliticaPrivacidad" 
                    name="consentForSelectionProcess"
                    [value]="true">
                    <label class="form-check-label" for="PoliticaPrivacidad">
                        Doy mi consentimiento para que mis datos sean utilizados en el proceso de selección de personal.
                    </label>
                </div>
            </div>
            <hr class="mt-3 mb-3" />
        </ng-container>
       
        <div class="mt-2 mb-2 text-end">
            <button (click)="reset()" type="button" class="btn btn-secondary me-2">
                Cancelar
            </button>
            <button (click)="submit()" type="button" class="btn btn-primary"
            [disabled]="isLoading()">
               @if(!isLoading()){
                  Guardar
               }@else {
                   <div class="spinner-border spinner-border-sm text-light" role="status">
                       <span class="visually-hidden">Loading...</span>
                   </div>
                   Guardando
               }
            </button>
        </div>
    </div>
</div>